module.exports = __webpack_public_path__ + "static/media/aires_poster.7b364e60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/projects/aires_poster.jpg
// module id = 168
// module chunks = 0